define('plugins/musicfavourite/nls/text',[
    'exports',
    './default',
    './standard',
    './eavis',
    './events',
    './iplayer',
    './music_guide',
    './playlister',
    './audiovideo',
    './playlist',
    './artist',
    './track',
    './radio',
    './management',
    './menuOptions',
    './sounds'
], function(exports, def, standard, eavis, events, iplayer, music_guide, playlister, audiovideo, playlist, artist, track, radio, management, menuOptions, sounds) {

    'use strict';

    exports = exports || {};

    exports.text = function(profile, cb) {
        profile = profile || 'default';

        var map = {
            'default': def,
            'standard': standard,
            'eavis': eavis,
            'events': events,
            'iplayer': iplayer,
            'music_guide': music_guide,
            'playlister': playlister,
            'audiovideo': audiovideo,
            'playlist': playlist,
            'artist': artist,
            'track': track,
            'radio': radio,
            'sounds': sounds
        };

        var o          = {};
        o.button       = map[profile].button;
        o.dialog       = map[profile].dialog;
        o.confirmation = map[profile].confirmation;
        o.management   = management;
        o.options      = menuOptions;

        cb(o);
    };

    return exports;
});
